import React from 'react'
import PropTypes from 'prop-types'
import ResponsiveClassesComponent from '../features/ui/util/responsive_classes_component'
import PillItem from './pill_item'
import { CX } from '../constants'

/**
 * Renders pills components
 * @param {array} [props.pills] - tab bar data for creating `TabBarItem`
 */
class Pills extends React.PureComponent {

  render() {
    const { pills, wrap } = this.props

    const classNamesXS = CX({
      d: 1,
      maxW100PC: 1,
      overflowYHidden: 1,
      overflowXScroll: !wrap,
      noScrollbar: 1,
      px10: 1,
      flexRow: 1,
      flexWrap: wrap,
    })

    return (
      <ResponsiveClassesComponent
        classNames={[_s.d, _s.flexWrap, _s.pr5, _s.flexRow].join(' ')}
        classNamesXS={classNamesXS}
      >
        {
          !!pills &&
          pills.map((tab, i) => (
            <PillItem
              key={`pill-item-${i}`}
              title={tab.title}
              onClick={tab.onClick}
              to={tab.to}
              isActive={tab.active}
              prependImage={tab.prependImage}
              prependIcon={tab.prependIcon}
              appendIcon={tab.appendIcon}
              isHidden={tab.isHidden}
              disabled={tab.disabled}
            />
          ))
        }
      </ResponsiveClassesComponent>
    )
  }

}

Pills.propTypes = {
  pills: PropTypes.array,
  wrap: PropTypes.bool,
}

export default Pills
